import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Nog geen modifiergroepen. Maak een nieuwe aan.',
  fields: {
    name: 'Naam',
    external_id: '{{integration}} ref',
    prices: 'Prijzen',
    available: 'Beschikbaar',
    status: 'Status',
    statuses: {
      good: 'Goed',
      bad: 'Slecht',
      medium: 'Gemiddeld',
    },
  },
  order_method_prices: {
    base: 'Basis',
    [ORDER_METHODS.pickup]: 'Afhalen',
    [ORDER_METHODS.delivery]: 'Bezorging',
    [ORDER_METHODS.on_site]: 'Tafelbestellen',
  },
  labels: {
    visible: 'Zichtbaar in menu',
    hidden: 'Alles verborgen',
  },
  buttons: {
    add_modifier: 'Modifier toevoegen',
    delete_modifier_one: 'Modifier verwijderen',
    delete_modifier_other: 'Modifiers verwijderen',
    show_modifier_group: 'Modifiergroep tonen',
    close_modifier_group: 'Modifiergroep sluiten',
    edit: 'Bewerken',
    duplicate: 'Dupliceren',
    history: 'Geschiedenis',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Dupliceren van modifiergroep mislukt',
    modifier_group_duplicated_successfully: 'Modifiergroep succesvol gedupliceerd',
    failed_to_duplicate_modifier: 'Dupliceren van modifier mislukt',
    modifier_duplicated_successfully: 'Modifier succesvol gedupliceerd',
  },
};
